import { reactive } from 'vue'
import { defineStore } from 'vue_features/shared/composables/store_helpers.js'

const DEFAULT_READOUT_DELAY = 10000

export const useAccessibilityAlertStore = defineStore('accessibilityAlert', () => {
  const state = reactive({
    queue: [],
    message: '',
    isProcessing: false,
    level: 'polite',
  })

  function processQueue() {
    if (state.isProcessing) return
    if (state.queue.length === 0) {
      state.isProcessing = false
      return
    }
    state.isProcessing = true
    const { message, delay, level } = state.queue.shift()
    state.message = message
    state.level = level
    setTimeout(() => {
      state.message = ''
      state.level = 'polite'
      state.isProcessing = false
      setTimeout(processQueue, 200)
    }, delay)
  }

  function enqueueNotification(newMessage, delay = DEFAULT_READOUT_DELAY, level = 'polite') {
    state.queue.push({ message: newMessage, delay, level })
    processQueue()
  }

  return {
    state,
    enqueueNotification,
  }
})
